import React from 'react';
import ManageExpendituresModal from '../../components/modals/ManageExpendituresModal';

function ExpenditureSection() {
    return <ManageExpendituresModal inline onClose={() => {}} />;
}

export default ExpenditureSection;
